<template>
  <div>
    <div v-if="results && generalInfo" class="">
      <div class="font-weight-600 ml-2 mb-4">Документы кандидата</div>
      <div v-if="results && generalInfo">
        <DossierTable />
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DossierTable from './dossier/DossierTable';

export default {
  name: 'ProfileData',
  components: {
    DossierTable
  },
  props: {
  },
  data: () => ({
    item: {
      position: ''
    }
  }),
  computed: {
    ...mapGetters({
      loading: 'users/candidate/loading',
      results: 'users/candidate/results',
    }),
    isProfile() {
      return this.$route.name === 'profile';
    },
    generalInfo() {
      return this.results?.general_info;
    },
  },
  methods: {
    ...mapActions({
      createTestingSession: 'testing/session/createTestingSession',
      deleteUnusedSession: 'users/candidate/deleteUnusedSession',
      loadCandidateResults: 'users/candidate/loadCandidateResults',
    }),
    ...mapMutations({
    }),
    onInput(field) {
      console.log(field);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

</style>
